/**
 * @component sg-inline-edit - component for inline editing of element values.
 *                              When clicked, value changes to an input and can be edited.
 *                              Esc wil cancel the change, removing the focus.
 *                              Press enter will commit the new value.
 * @param element {Object} - Object that contains our ng-model
 * @param key {String} - element[key] will be our ng-model
 * @param inputType {String} - Enum: [string, number, select, longstring]
 * @param [float] {Number | Boolean} - If inputType === 'number' this allows to set the float precision. Defaults to 0.
 * @param [allowNegative] {Boolean} - If true, will accept negative numbers. defaults to false
 * @param onUpdate {Promise} - Callback to parent when an item is updated. Receives these params: element, value, key
 * @param canWrite {Boolean} - Indicates if the field is editable (usefull for project role authorization)
 * @param inputId {String} - Id to set on the display/editable DOM element
 * @param [language] {String} - Language to use for paragraph spellchecker
 *
  usage:
    <sg-inline-edit element="element" on-update="$ctrl.submitElement(element, value)"></sg-inline-edit>


  on-update [function] : must return a promise

*/

'use strict';

(() => {

  angular
    .module('specsguardApp')
    .component('sgInlineEdit', {
      templateUrl: 'app-legacy/components/sg-inline-edit/sg-inline-edit.html',
      bindings: {
        inputType: '@',
        key: '@',
        element: '<',
        value: '=?',
        float: '<',
        step: '@',
        allowNegative: '<',
        onUpdate: '&',
        canWrite: '<',
        inputId: '@',
        language: '@?',
        enableEditMode: '<',
        openInModal: '<'
      },
      controller: 'sgInlineEditCtrl',
    });

})();
